import Api from '@/vuex/api'
import { app } from '@/main'
import {
  ADD_CREDITS,
  ADD_ACCOUNT_NOTE,
  ADD_SMARTCARD,
  APPROVE_APPLICATION,
  BLACKLIST_MEMBER,
  UN_BLACKLIST_MEMBER,
  CAPTURE_HELD_CHARGE,
  CHANGE_PASS_USER,
  CHANGE_PLAN_USER,
  CHARGE_ACCOUNT,
  CHARGE_DRIVER,
  CHARGE_MEMBERSHIP,
  CHARGE_SETUP,
  CHECK_APPLICATION,
  CREATE_PENDING_CHARGE,
  DECLINE_APPLICATION,
  DELETE_CREDIT_CARD,
  DELETE_APPLICATION,
  DOWNLOAD_WELCOME_LETTER,
  DISMISS_NOTIFICATIONS,
  DISMISS_NOTIFICATION,
  EDIT_APPLICATION,
  EDIT_SMARTCARD,
  EDIT_CREDIT_CARD_NICKNAME,
  EDIT_CREDIT_CARD_TYPE,
  EMAIL_APPLICATION,
  FILL_APPLICATION,
  GENERATE_MONTHLY_INVOICE,
  FLAG_APPLICATION,
  INVITE_DRIVER,
  LOAD_APPLICATION,
  LOAD_HELD_CHARGE,
  LOAD_NOTIFICATIONS,
  LOAD_NOTIFICATIONS_COUNT,
  LOAD_SMART_CARD,
  LOAD_USER,
  LOAD_USER_ALERTS,
  LOAD_USER_CREDIT_CARDS,
  LOAD_USER_FILES,
  LOAD_USER_FILES_TOTAL,
  LOAD_USER_FILES_COLUMNS,
  LOAD_USER_LEDGER,
  LOAD_USER_LEDGER_COLUMNS,
  LOAD_USER_DRIVERS,
  LOAD_USER_DRIVERS_COLUMNS,
  LOAD_USER_DRIVERS_TOTAL,
  LOAD_USER_RESERVATIONS,
  LOAD_USER_RESERVATIONS_TOTAL,
  LOAD_USER_RESERVATIONS_COLUMNS,
  LOAD_USER_NOTES,
  LOAD_USER_NOTES_TOTAL,
  LOGIN_AS_USER,
  LOGIN,
  LOGOUT,
  MAKE_ACTIVE,
  MAKE_INACTIVE,
  MAKE_MASTER_ACCOUNT,
  MOVE_TO_APPLICATIONS,
  NEW_RESERVATION_USER,
  OPEN_MODAL,
  QUIT_MEMBER,
  REFUND_CHARGE,
  REFUND_PENDING_CHARGE,
  RELEASE_HELD_CHARGE,
  REJOIN_MEMBER,
  REMOVE_DRIVER,
  RESTRICT_MEMBER,
  SEND_GUARANTOR_FORM,
  SNOOZE_NOTIFICATION,
  SNOOZE_NOTIFICATIONS,
  TOGGLE_ALERT,
  UNASSIGN_SMARTCARD,
  UNFLAG_APPLICATION,
  UNRESTRICT_MEMBER,
  UPLOAD_GUARANTOR_FORM,
  UPLOAD_FILE,
  WAIVE_MEMBERSHIP
} from '@/vuex/types'

const api = new Api()
const state = {
  user: {
    uuid: '',
    emailPrefs: [],
    allAlerts: [],
    AccountType: {},
    AmazonImages: [],
    AmazonImagesTotal: 0,
    AmazonImagesColumns: [],
    AccountMessages: [],
    CreditCards: [],
    Drivers: [],
    DriversTotal: 0,
    DriversColumns: [],
    HeldCharge: {
      Account: {},
      ReservationCharges: [],
      BulkCharges: []
    },
    HeldCharges: [],
    Ledger: [],
    LedgerColumns: [],
    Notes: [],
    NotesTotal: 0,
    Reservations: [],
    ReservationsTotal: 0,
    ReservationColumns: [],
    Smartcard: {},
    MemberDiscount: {
      AdminResponsible: {},
      AdminApproved: {}
    },
    totalAccountPayments: 0,
    totalAccountSales: 0,
    totalCreditsGiven: 0
  },
  loggedIn: true,
  userActions: [
    { label: 'Edit Account', command: EDIT_APPLICATION, icon: 'fa fa-pencil-alt' },
    { label: 'Log In As User', command: LOGIN_AS_USER, icon: 'fa fa-sign-in-alt' },
    { label: 'New Reservation', command: NEW_RESERVATION_USER, icon: 'fa fa-calendar-alt' },
    { label: 'Change Password', command: CHANGE_PASS_USER, icon: 'fa fa-key' },
    { label: 'Invite Driver', command: INVITE_DRIVER, icon: 'fa fa-user-plus' },
    { label: 'Change Plan', command: CHANGE_PLAN_USER, icon: 'fa fa-random' },
    { label: 'Edit Smartcard', command: EDIT_SMARTCARD, icon: 'fa fa-id-card' },
    { label: 'Unassign Smartcard', command: UNASSIGN_SMARTCARD, icon: 'fa fa-times' },
    { label: 'Add Smartcard', command: ADD_SMARTCARD, icon: 'fa fa-id-card' },
    { label: 'Add Note', command: ADD_ACCOUNT_NOTE, icon: 'fa fa-sticky-note' },
    { label: 'Upload File', command: UPLOAD_FILE, icon: 'fa fa-upload' },
    { label: 'Restrict Member', command: RESTRICT_MEMBER, icon: 'fa fa-exclamation-triangle' },
    { label: 'Blacklist Member', command: BLACKLIST_MEMBER, icon: 'fa fa-ban' },
    { label: 'Un-Blacklist Member', command: UN_BLACKLIST_MEMBER, icon: 'fa fa-lock-open' },
    { label: 'Unrestrict Member', command: UNRESTRICT_MEMBER, icon: 'fa fa-exclamation-triangle' },
    { label: 'Make Inactive', command: MAKE_INACTIVE, icon: 'fa fa-clock' },
    { label: 'Make Active', command: MAKE_ACTIVE, icon: 'fa fa-clock' },
    { label: 'Quit Member', command: QUIT_MEMBER, icon: 'fa fa-user-times' },
    { label: 'Re-join Member', command: REJOIN_MEMBER, icon: 'fa fa-user-plus' }
  ],
  driverActions: [
    { label: 'Make Master Account', command: MAKE_MASTER_ACCOUNT, icon: 'fa fa-users' },
    { label: 'Remove Driver', command: REMOVE_DRIVER, icon: 'fa fa-trash-alt' }
  ],
  applicationActions: [
    { label: 'Email Link To Complete Application', command: EMAIL_APPLICATION, icon: 'fa fa-envelope' },
    { label: 'Download Welcome Letter', command: DOWNLOAD_WELCOME_LETTER, icon: 'fa fa-download' },
    { label: 'Application Flagged', command: 'flagged', labelOnly: true, icon: 'fa fa-exclamation-triangle' },
    { label: 'Fill Application', command: FILL_APPLICATION, icon: 'far fa-circle' },
    { label: 'Application Filled', command: 'filled', labelOnly: true, icon: 'fa fa-check-circle' },
    { label: 'Mark as checked', command: CHECK_APPLICATION, icon: 'far fa-circle' },
    { label: 'Application Checked', command: 'checked', labelOnly: true, icon: 'fa fa-check-circle' },
    { label: 'Move to Applications', command: MOVE_TO_APPLICATIONS, icon: 'fa fa-arrow-alt-circle-right' },
    { label: 'Charge Membership Fee', command: CHARGE_MEMBERSHIP, icon: 'far fa-circle' },
    { label: 'Waive Membership Fee', command: WAIVE_MEMBERSHIP, icon: 'far fa-circle' },
    { label: 'Membership Fee Paid', command: 'membershipPaid', labelOnly: true, icon: 'fa fa-check-circle' },
    { label: 'Charge Setup Fee', command: CHARGE_SETUP, icon: 'far fa-circle' },
    { label: 'Setup Fee Paid', command: 'setupPaid', labelOnly: true, icon: 'fa fa-check-circle' },
    { label: 'Charge Driver Fee', command: CHARGE_DRIVER, icon: 'far fa-circle' },
    { label: 'Driver Fee Paid', command: 'driverPaid', labelOnly: true, icon: 'fa fa-check-circle' },
    { label: 'Add Smartcard', command: ADD_SMARTCARD, icon: 'far fa-circle' },
    { label: 'Smartcard Assigned', command: 'smartcardAssigned', labelOnly: true, icon: 'fa fa-check-circle' },
    { label: 'Edit Smartcard', command: EDIT_SMARTCARD, icon: 'fa fa-id-card' },
    { label: 'Unassign Smartcard', command: UNASSIGN_SMARTCARD, icon: 'fa fa-times' },
    { label: 'Approve Application', command: APPROVE_APPLICATION, icon: 'fa fa-envelope' },
    { label: 'Flag Application', command: FLAG_APPLICATION, icon: 'fa fa-flag' },
    { label: 'Blacklist Member', command: BLACKLIST_MEMBER, icon: 'fa fa-gavel' },
    { label: 'Unflag Application', command: UNFLAG_APPLICATION, icon: 'fa fa-undo' },
    { label: 'Decline', command: DECLINE_APPLICATION, icon: 'fa fa-ban' },
    { label: 'Edit Application', command: EDIT_APPLICATION, icon: 'fa fa-pencil-alt' },
    { label: 'Delete Application', command: DELETE_APPLICATION, icon: 'fa fa-trash-alt' },
    { label: 'Add Note', command: ADD_ACCOUNT_NOTE, icon: 'fa fa-sticky-note' }
  ],
  billingActions: [
    { label: 'Generate Monthly Invoice', command: GENERATE_MONTHLY_INVOICE, icon: 'fa fa-file-alt' },
    { label: 'Add Credits', command: ADD_CREDITS, icon: 'fa fa-dollar-sign' },
    { label: 'Charge Account', command: CHARGE_ACCOUNT, icon: 'fa fa-credit-card' }
  ]
}

const getters = {
  isLoggedIn ({ loggedIn }) {
    return loggedIn
  },
  driverActions ({ driverActions }) {
    return driverActions
  },
  loadedUser ({ user }) {
    let overdue = false
    if (user.AccountType.annualFee) {
      if (moment().diff(moment(user.membershipLastPaid), 'months', true) > 12) {
        overdue = true
      }
    } else if (user.AccountType.monthlyFee) {
      if (moment().diff(moment(user.membershipLastPaid), 'months', true) > 6) {
        overdue = true
      }
    }
    return { ...user, overdue }
  },
  userActions: ({ userActions }) => (user, admin) => {
    let excludeActions = []
    if (user.AccountType.superAdministrator || !admin.AccountType.financeAdministrator) {
      excludeActions.push(LOGIN_AS_USER)
      excludeActions.push(CHANGE_PASS_USER)
    }
    if (user.cardId) excludeActions.push(ADD_SMARTCARD)
    else excludeActions.push(EDIT_SMARTCARD)
    if (!user.restricted) excludeActions.push(UNRESTRICT_MEMBER)
    else excludeActions.push(RESTRICT_MEMBER)
    if (!user.blacklisted) excludeActions.push(UN_BLACKLIST_MEMBER)
    else excludeActions.push(BLACKLIST_MEMBER)
    if (!user.activated) excludeActions.push(MAKE_INACTIVE)
    else excludeActions.push(MAKE_ACTIVE)
    if (!user.memberQuit) excludeActions.push(REJOIN_MEMBER)
    else excludeActions.push(QUIT_MEMBER)
    return userActions.filter(el => !excludeActions.includes(el.command))
  },
  billingActions: ({ billingActions }) => (user, admin) => {
    let excludeActions = []
    if (!admin.AccountType.financeAdministrator) {
      excludeActions = excludeActions.concat([ ADD_CREDITS, CHARGE_ACCOUNT ])
    }
    return billingActions.filter(el => !excludeActions.includes(el.command))
  },
  applicationActions: ({ applicationActions }, { applicationFilled }) => (app, admin) => {
    let excludeActions = []
    let isBusiness = app.AccountType.name === 'Business'
    // flagged status
    if (app.applicationFlagged) excludeActions.push(FLAG_APPLICATION)
    else {
      excludeActions = excludeActions.concat([ UNFLAG_APPLICATION, 'flagged' ])
    }
    if (applicationFilled(app)) {
      // application filled
      excludeActions.push(FILL_APPLICATION)
    } else {
      // if its not filled remove future steps
      excludeActions = excludeActions.concat([
        'filled',
        APPROVE_APPLICATION,
        ADD_SMARTCARD,
        UNASSIGN_SMARTCARD,
        EDIT_SMARTCARD,
        'smartcardAssigned',
        CHECK_APPLICATION
      ])
    }
    // application move process
    if (!app.declined && !app.memberQuit) {
      excludeActions.push(MOVE_TO_APPLICATIONS)
    } else {
      excludeActions = excludeActions.concat([
        FILL_APPLICATION,
        'filled',
        CHECK_APPLICATION,
        'checked',
        CHARGE_MEMBERSHIP,
        WAIVE_MEMBERSHIP,
        CHARGE_SETUP,
        CHARGE_DRIVER,
        ADD_SMARTCARD,
        EDIT_SMARTCARD,
        FLAG_APPLICATION,
        UNFLAG_APPLICATION,
        DECLINE_APPLICATION
      ])
    }
    if (app.applicationReviewed) {
      // already reviewed
      excludeActions.push(CHECK_APPLICATION)
      if (app.isMasterAccount) {
        // non-drivers
        excludeActions = excludeActions.concat([
          CHARGE_DRIVER,
          'driverPaid'
        ])
        if (!isBusiness) {
          // business
          excludeActions = excludeActions.concat([
            CHARGE_SETUP,
            'setupPaid'
          ])
        } else {
          // non business
          excludeActions = excludeActions.concat([
            CHARGE_MEMBERSHIP,
            'membershipPaid'
          ])
        }
      } else {
        // drivers
        excludeActions = excludeActions.concat([
          CHARGE_SETUP,
          CHARGE_MEMBERSHIP,
          'setupPaid',
          'membershipPaid'
        ])
      }
      if (!app.membershipLastPaid) {
        // haven't paid
        excludeActions = excludeActions.concat([
          ADD_SMARTCARD,
          'smartcardAssigned',
          UNASSIGN_SMARTCARD,
          EDIT_SMARTCARD,
          APPROVE_APPLICATION,
          'membershipPaid'
        ])
      } else {
        // paid
        excludeActions = excludeActions.concat([
          WAIVE_MEMBERSHIP, CHARGE_MEMBERSHIP, CHARGE_DRIVER
        ])
        if (app.cardId) {
          // assigned smartcard
          excludeActions = excludeActions.concat([
            ADD_SMARTCARD
          ])
        } else {
          // unassigned
          excludeActions = excludeActions.concat([
            'smartcardAssigned',
            UNASSIGN_SMARTCARD,
            EDIT_SMARTCARD,
            APPROVE_APPLICATION
          ])
        }
      }
    } else {
      // if the application hasn't been checked
      excludeActions = excludeActions.concat([
        CHARGE_MEMBERSHIP,
        WAIVE_MEMBERSHIP,
        CHARGE_DRIVER,
        CHARGE_SETUP,
        'checked',
        APPROVE_APPLICATION,
        ADD_SMARTCARD,
        UNASSIGN_SMARTCARD,
        EDIT_SMARTCARD,
        'smartcardAssigned'
      ])
    }
    if (!app.membershipLastPaid) {
      excludeActions = excludeActions.concat([
        'membershipPaid',
        'driverPaid',
        'setupPaid',
        APPROVE_APPLICATION
      ])
    }
    if (!app.applicationComplete) {
      excludeActions.push(DECLINE_APPLICATION)
    }
    if (app.memberQuit && !app.activated && !app.applicationApproved) {
      excludeActions.push(DELETE_APPLICATION)
    }
    if (!admin.AccountType.financeAdministrator) {
      excludeActions.push(APPROVE_APPLICATION)
    }
    if (app.Organization.useExternalAuth) {
      excludeActions.push(EMAIL_APPLICATION)
    }
    return applicationActions.filter(el => !excludeActions.includes(el.command))
  },
  applicationFilled: () => (app) => {
    let isBusiness = app.AccountType.name === 'Business'
    let isStudent = app.AccountType.name === 'Student'
    let businessValid = true
    let studentValid = true
    if (isBusiness) {
      businessValid = app.businessName &&
      app.businessAddress && app.businessAbn
    }
    if (isStudent && !app.Organization.useExternalAuth) {
      studentValid = app.ProofOfEnrolment
    }
    let validDocs = app.DriversLicense &&
      app.DriversLicenseBack &&
      app.ProofOfAddress
    if (app.Organization.useExternalAuth && app.DriversLicense && app.DriversLicenseBack) {
      validDocs = true
    }
    return app.email &&
      app.firstName &&
      app.lastName &&
      app.address &&
      app.suburb &&
      app.postcode &&
      app.state &&
      app.homePhone &&
      app.dateOfBirth &&
      app.gender &&
      app.emergencyFirstName &&
      app.emergencyLastName &&
      app.emergencyPhone &&
      app.emergencyRelation &&
      app.driversLicense &&
      app.driversLicenseIssued &&
      app.driversLicenseExpiry &&
      app.driversYears &&
      businessValid && studentValid && validDocs
  },
  userHeldCharge (state) {
    return state.user.HeldCharge
  },
  userNotifications (state) {
    return state.user.AccountMessages
  },
  userNotificationsCount (state) {
    return state.user.AccountMessages.length
  },
  userReservations (state) {
    return state.user.Reservations
  },
  userReservationsTotal (state) {
    return state.user.ReservationsTotal
  },
  userReservationsColumns (state) {
    return state.user.ReservationColumns
  },
  userFiles (state) {
    return state.user.AmazonImages
  },
  userFilesTotal (state) {
    return state.user.AmazonImagesTotal
  },
  userFilesColumns (state) {
    return state.user.AmazonImagesColumns
  },
  userNotes (state) {
    return state.user.Notes
  },
  userNotesTotal (state) {
    return state.user.NotesTotal
  },
  userLedgerColumns (state) {
    return state.user.LedgerColumns
  },
  userLedger (state) {
    return state.user.Ledger
  },
  userDriversColumns (state) {
    return state.user.DriversColumns
  },
  userDriversTotal (state) {
    return state.user.DriversTotal
  },
  userDrivers (state) {
    return state.user.Drivers
  }
}

const mutations = {
  [LOGIN] (state) {
    state.loggedIn = true
  },
  [LOGOUT] (state) {
    state.loggedIn = false
  },
  [LOAD_USER_ALERTS] (state, emailPrefs) {
    state.user = { ...state.user, emailPrefs }
  },
  [LOAD_HELD_CHARGE] (state, heldCharge) {
    state.user = { ...state.user, HeldCharge: heldCharge }
  },
  [LOAD_NOTIFICATIONS] (state, accountMessages) {
    state.user = { ...state.user, AccountMessages: accountMessages }
  },
  [LOAD_SMART_CARD] (state, smartCard) {
    state.user = { ...state.user, Smartcard: smartCard }
  },
  [LOAD_USER_LEDGER] (state, ledger) {
    state.user = { ...state.user, Ledger: ledger }
  },
  [LOAD_USER_LEDGER_COLUMNS] (state, columns) {
    state.user = { ...state.user, LedgerColumns: columns }
  },
  [LOAD_USER_DRIVERS] (state, drivers) {
    state.user = { ...state.user, Drivers: drivers }
  },
  [LOAD_USER_DRIVERS_COLUMNS] (state, columns) {
    state.user = { ...state.user, DriversColumns: columns }
  },
  [LOAD_USER_DRIVERS_TOTAL] (state, total) {
    state.user = { ...state.user, DriversTotal: total }
  },
  [LOAD_USER_RESERVATIONS_COLUMNS] (state, columns) {
    state.user = { ...state.user, ReservationColumns: columns }
  },
  [LOAD_USER] (state, payload) {
    state.user = { ...state.user, ...payload.user }
  },
  [LOAD_USER_RESERVATIONS] (state, reservations) {
    state.user = { ...state.user, Reservations: reservations }
  },
  [LOAD_USER_RESERVATIONS_TOTAL] (state, count) {
    state.user = { ...state.user, ReservationsTotal: count }
  },
  [LOAD_USER_FILES] (state, files) {
    state.user = { ...state.user, AmazonImages: files }
  },
  [LOAD_USER_CREDIT_CARDS] (state, cards) {
    state.user = { ...state.user, CreditCards: cards }
  },
  [LOAD_USER_FILES_TOTAL] (state, count) {
    state.user = { ...state.user, AmazonImagesTotal: count }
  },
  [LOAD_USER_FILES_COLUMNS] (state, columns) {
    state.user = { ...state.user, AmazonImagesColumns: columns }
  },
  [LOAD_USER_NOTES] (state, notes) {
    state.user = { ...state.user, Notes: notes }
  },
  [LOAD_USER_NOTES_TOTAL] (state, count) {
    state.user = { ...state.user, NotesTotal: count }
  }
}

const actions = {
  [LOGIN] (context, token) {
    window.sessionStorage.setItem('token', token)
    context.commit(LOGIN)
  },
  async [LOGOUT] (context) {
    await api.logout()
    window.sessionStorage.removeItem('token')
    context.commit(LOGOUT)
  },
  async [LOAD_APPLICATION] (context, applicationUuid) {
    let application = await api.getApplication(applicationUuid)
    context.commit(LOAD_USER, { user: application })
  },
  async [LOAD_USER] (context, accountUuid) {
    let { account, emailPrefs, totalAccountPayments, totalAccountSales, totalCreditsGiven, allAlerts } = await api.getUser(accountUuid)
    context.commit(LOAD_USER, { user: { ...account, emailPrefs, totalAccountPayments, totalAccountSales, totalCreditsGiven, allAlerts } })
  },
  async [TOGGLE_ALERT] (context, payload) {
    let alerts = await api.toggleAlert({
      alertUuid: payload.alertData.alert.uuid,
      accountUuid: payload.accountUuid,
      on: payload.alertData.on
    })
    context.commit(LOAD_USER_ALERTS, alerts)
  },
  async [LOAD_NOTIFICATIONS] (context) {
    let accountMessages = await api.getAccountMessages()
    context.commit(LOAD_NOTIFICATIONS, accountMessages)
  },
  async [LOAD_HELD_CHARGE] (context, heldChargeUuid) {
    let heldCharge = await api.getHeldCharge(heldChargeUuid)
    context.commit(LOAD_HELD_CHARGE, heldCharge)
  },
  async [EMAIL_APPLICATION] (context, application) {
    await api.sendApplicationLink(application.uuid)
    let successModal = {
      title: 'Email sent',
      html: 'Email succesfully sent to applicant'
    }
    context.dispatch(OPEN_MODAL, successModal)
  },
  async [FILL_APPLICATION] (context, application) {
    app.$router.push(`/membership/applications/edit/${application.uuid}`)
  },
  async [EDIT_APPLICATION] (context, application) {
    if (application.applicationApproved) {
      app.$router.push(`/membership/members/edit/${application.uuid}`)
    } else {
      app.$router.push(`/membership/applications/edit/${application.uuid}`)
    }
  },
  async [CHECK_APPLICATION] (context, application) {
    let data = await api.checkApplication(application.uuid)
    return data
  },
  async [MOVE_TO_APPLICATIONS] (context, application) {
    await api.moveApplication(application.uuid)
    app.$router.push(`/membership/applications/${application.uuid}`)
  },
  async [CHARGE_MEMBERSHIP] (context, application) {
    let resultModal = {
      redirect: '/membership/applications/' + application.uuid,
      title: 'Success',
      html: ''
    }
    try {
      let message = await api.chargeMembershipFee(application.uuid)
      resultModal.html = message
    } catch (e) {
      resultModal.title = 'Error'
      resultModal.html = e.Error || e.error || e
    }
    context.dispatch(OPEN_MODAL, resultModal)
  },
  async [CHARGE_SETUP] (context, application) {
    let resultModal = {
      redirect: '/membership/applications/' + application.uuid,
      title: 'Success',
      html: ''
    }
    try {
      let message = await api.chargeMembershipFee(application.uuid)
      resultModal.html = message
    } catch (e) {
      resultModal.title = 'Error'
      resultModal.html = e.Error || e.error || e
    }
    context.dispatch(OPEN_MODAL, resultModal)
  },
  async [WAIVE_MEMBERSHIP] (context, application) {
    let waiveFeeModal = {
      permalink: 'waiveMembershipFee',
      options: {
        title: 'Waive Membership Fee',
        actionLabel: 'Waive'
      },
      params: {
        applicationUuid: application.uuid
      }
    }
    context.dispatch(OPEN_MODAL, waiveFeeModal)
  },
  async [CHARGE_DRIVER] (context, application) {
    let resultModal = {
      redirect: '/membership/applications/' + application.uuid,
      title: 'Success',
      html: ''
    }
    try {
      let message = await api.chargeMembershipFee(application.uuid)
      resultModal.html = message
    } catch (e) {
      resultModal.title = 'Error'
      resultModal.html = e.Error || e.error || e
    }
    context.dispatch(OPEN_MODAL, resultModal)
  },
  async [UNASSIGN_SMARTCARD] (context, payload) {
    let uuid = payload.uuid
    if (payload.AccountUuid) {
      uuid = payload.AccountUuid
    }
    let unassignSmartCardModal = {
      permalink: 'unassignSmartcard',
      options: {
        title: 'Unassign Smartcard',
        actionLabel: 'Unassign'
      },
      params: {
        AccountUuid: uuid
      }
    }
    context.dispatch(OPEN_MODAL, unassignSmartCardModal)
  },
  async [APPROVE_APPLICATION] (context, application) {
    await api.approveApplication(application.uuid)
    app.$router.push(`/membership/members/${application.uuid}`)
  },
  async [FLAG_APPLICATION] (context, application) {
    let data = await api.flagApplication(application.uuid)
    return data
  },
  async [UNFLAG_APPLICATION] (context, application) {
    let data = await api.unflagApplication(application.uuid)
    return data
  },
  async [DECLINE_APPLICATION] (context, application) {
    let declineModal = {
      permalink: 'declineApplication',
      options: {
        title: 'Decline Application',
        actionLabel: 'Decline and Send'
      },
      params: {
        applicationUuid: application.uuid
      }
    }
    context.dispatch(OPEN_MODAL, declineModal)
  },
  async [DELETE_APPLICATION] (context, application) {
    await api.deleteApplication(application.uuid)
    app.$router.push(`/membership/applications/${application.uuid}`)
  },
  async [EDIT_CREDIT_CARD_TYPE] (context, cardUuid) {
    let updated = await api.editCreditCardType(cardUuid)
    return { updated }
  },
  async [EDIT_CREDIT_CARD_NICKNAME] (context, cardUuid) {
    let editCreditCardModal = {
      permalink: 'editCreditCardNickname',
      options: {
        title: 'Edit Credit Card Nickname',
        actionLabel: 'Save'
      },
      params: {
        CreditCardUuid: cardUuid
      }
    }
    context.dispatch(OPEN_MODAL, editCreditCardModal)
  },
  async [DELETE_CREDIT_CARD] (context, cardUuid) {
    let deleteCreditCardModal = {
      permalink: 'deleteCreditCard',
      options: {
        title: 'Delete Credit Card',
        actionLabel: 'Delete'
      },
      params: {
        CreditCardUuid: cardUuid
      }
    }
    context.dispatch(OPEN_MODAL, deleteCreditCardModal)
  },
  async [SEND_GUARANTOR_FORM] (context, payload) {
    await api.sendGuarantorForm(payload.application.uuid)
    app.$router.push(`/membership/applications/${payload.application.uuid}`)
  },
  async [UPLOAD_GUARANTOR_FORM] (context, payload) {
    let uploadModal = {
      permalink: 'uploadGuarantorForm',
      options: {
        title: 'Upload Guarantor Form',
        actionLabel: 'Upload'
      },
      params: {
        applicationUuid: payload.application.uuid
      }
    }
    context.dispatch(OPEN_MODAL, uploadModal)
  },
  async [ADD_ACCOUNT_NOTE] (context, account) {
    let accountUuid = context.state.user.uuid
    if (account) accountUuid = account.uuid
    let noteModal = {
      permalink: 'newNote',
      options: {
        title: 'Add Note',
        actionLabel: 'Add Note'
      },
      params: { accountUuid }
    }
    context.dispatch(OPEN_MODAL, noteModal)
  },
  async [GENERATE_MONTHLY_INVOICE] (context, account) {
    let invoiceModal = {
      permalink: 'monthlyInvoice',
      options: {
        title: 'Monthly Invoice',
        actionLabel: 'Send Email'
      },
      params: {
        AccountUuid: account.uuid
      }
    }
    context.dispatch(OPEN_MODAL, invoiceModal)
  },
  async [UPLOAD_FILE] (context, account) {
    let accountUuid = context.state.user.uuid
    if (account) accountUuid = account.uuid
    let uploadModal = {
      permalink: 'uploadFile',
      options: {
        title: 'Upload File',
        actionLabel: 'Upload'
      },
      params: { accountUuid }
    }
    context.dispatch(OPEN_MODAL, uploadModal)
  },
  [ADD_CREDITS] (context, account) {
    let creditModal = {
      permalink: 'addCredits',
      options: {
        title: 'Add Credits',
        actionLabel: 'Add Credits'
      },
      params: {
        accountUuid: account.uuid
      }
    }
    context.dispatch(OPEN_MODAL, creditModal)
  },
  [CHARGE_ACCOUNT] (context, account) {
    let chargeAccountModal = {
      permalink: 'chargeAccount',
      options: {
        title: 'Charge Account',
        actionLabel: 'Charge'
      },
      params: {
        AccountUuid: account.uuid
      }
    }
    context.dispatch(OPEN_MODAL, chargeAccountModal)
  },
  [QUIT_MEMBER] (context, account) {
    let quitModal = {
      permalink: 'quitMember',
      options: {
        title: 'Confirm Quit Member',
        actionLabel: 'Quit Member'
      },
      params: {
        accountUuid: account.uuid
      }
    }
    context.dispatch(OPEN_MODAL, quitModal)
  },
  [REJOIN_MEMBER] (context, account) {
    let rejoinModal = {
      permalink: 'rejoinMember',
      options: {
        title: 'Confirm Rejoin Member',
        actionLabel: 'Rejoin Member'
      },
      params: {
        accountUuid: account.uuid
      }
    }
    context.dispatch(OPEN_MODAL, rejoinModal)
  },
  async [LOGIN_AS_USER] (context, account) {
    let link = await api.loginAsUser(account)
    let html = `
      <p>
        <strong>User:</strong> ${account.dropdownLabel}
      </p>
      <div class="alert alert-info">
        <strong>
          Remember to log out of the account once finished.
        </strong>
      </div>
      <p>
        ${link}
      </p>
    `
    let loginAsUserModal = {
      title: 'Login As User',
      html
    }
    context.dispatch(OPEN_MODAL, loginAsUserModal)
  },
  [NEW_RESERVATION_USER] (context, account) {
    app.$router.push(`/fleet/reservations/new/?d=${account.uuid}`)
  },
  [CHANGE_PASS_USER] (context, account) {
    let changePassword = {
      permalink: 'changePassword',
      options: {
        title: 'Change Password',
        actionLabel: 'Save'
      },
      params: {
        AccountUuid: account.uuid
      }
    }
    context.dispatch(OPEN_MODAL, changePassword)
  },
  [EDIT_SMARTCARD] (context, account) {
    let addSmartCardModal = {
      permalink: 'addSmartcard',
      options: {
        title: 'Edit Smartcard',
        actionLabel: 'Edit'
      },
      params: {
        AccountUuid: account.uuid
      }
    }
    context.dispatch(OPEN_MODAL, addSmartCardModal)
  },
  [ADD_SMARTCARD] (context, account) {
    let addSmartCardModal = {
      permalink: 'addSmartcard',
      options: {
        title: 'Assign Smartcard',
        actionLabel: 'Assign'
      },
      params: {
        AccountUuid: account.uuid
      }
    }
    context.dispatch(OPEN_MODAL, addSmartCardModal)
  },
  [RESTRICT_MEMBER] (context, account) {
    let restrictModal = {
      permalink: 'restrictMember',
      options: {
        title: 'Confirm Restrict Member',
        actionLabel: 'Restrict Member'
      },
      params: {
        accountUuid: account.uuid
      }
    }
    context.dispatch(OPEN_MODAL, restrictModal)
  },
  [BLACKLIST_MEMBER] (context, account) {
    let blacklistModal = {
      permalink: 'blacklistMember',
      options: {
        title: 'Confirm Blacklist Member',
        actionLabel: 'Blacklist Member'
      },
      params: {
        accountUuid: account.uuid
      }
    }
    context.dispatch(OPEN_MODAL, blacklistModal)
  },
  [UN_BLACKLIST_MEMBER] (context, account) {
    let blacklistModal = {
      permalink: 'unblacklistMember',
      options: {
        title: 'Confirm Un-Blacklist Member',
        actionLabel: 'Un-Blacklist Member'
      },
      params: {
        accountUuid: account.uuid
      }
    }
    context.dispatch(OPEN_MODAL, blacklistModal)
  },
  [UNRESTRICT_MEMBER] (context, account) {
    let unrestrictModal = {
      permalink: 'unrestrictMember',
      options: {
        title: 'Confirm Unrestrict Member',
        actionLabel: 'Unrestrict Member'
      },
      params: {
        accountUuid: account.uuid
      }
    }
    context.dispatch(OPEN_MODAL, unrestrictModal)
  },
  [MAKE_INACTIVE] (context, account) {
    let deactivateModal = {
      permalink: 'deactivateMember',
      options: {
        title: 'Confirm Make Member Inactive',
        actionLabel: 'Make Inactive'
      },
      params: {
        accountUuid: account.uuid
      }
    }
    context.dispatch(OPEN_MODAL, deactivateModal)
  },
  [MAKE_ACTIVE] (context, account) {
    let activateModal = {
      permalink: 'activateMember',
      options: {
        title: 'Confirm Make Member Active',
        actionLabel: 'Make Active'
      },
      params: {
        accountUuid: account.uuid
      }
    }
    context.dispatch(OPEN_MODAL, activateModal)
  },
  [CHANGE_PLAN_USER] (context, account) {
    let changePlanModal = {
      permalink: 'changePlan',
      options: {
        title: 'Change Membership Plan',
        actionLabel: 'Change Plan'
      },
      params: {
        accountUuid: account.uuid
      }
    }
    context.dispatch(OPEN_MODAL, changePlanModal)
  },
  [INVITE_DRIVER] (context, account) {
    let inviteModal = {
      permalink: 'inviteDriver',
      options: {
        title: 'Invite Driver',
        actionLabel: 'Invite'
      },
      params: {
        AccountUuid: account.uuid
      }
    }
    context.dispatch(OPEN_MODAL, inviteModal)
  },
  async [MAKE_MASTER_ACCOUNT] (context, payload) {
    let changeMasterAccount = {
      permalink: 'makeMasterAccount',
      options: {
        title: 'Confirm Change Master Account',
        actionLabel: 'Confirm'
      },
      params: {
        DriverUuid: payload.uuid
      }
    }
    context.dispatch(OPEN_MODAL, changeMasterAccount)
  },
  async [REMOVE_DRIVER] (context, payload) {
    let removeDriver = {
      permalink: 'removeDriver',
      options: {
        title: 'Confirm Remove Driver',
        actionLabel: 'Confirm'
      },
      params: {
        DriverUuid: payload.uuid
      }
    }
    context.dispatch(OPEN_MODAL, removeDriver)
  },
  async [REFUND_PENDING_CHARGE] (context, payload) {
    let refundPendingChargeModal = {
      permalink: 'refundPendingCharge',
      options: {
        title: 'Refund Charge',
        actionLabel: 'Refund'
      },
      params: {
        ChargeUuid: payload.ChargeUuid,
        modelName: payload.modelName,
        AccountUuid: payload.AccountUuid
      }
    }
    context.dispatch(OPEN_MODAL, refundPendingChargeModal)
  },
  async [REFUND_CHARGE] (context, payload) {
    let refundPendingChargeModal = {
      permalink: 'refundCharge',
      options: {
        title: 'Refund Charge',
        actionLabel: 'Refund'
      },
      params: {
        ChargeUuid: payload.ChargeUuid,
        modelName: payload.modelName,
        AccountUuid: payload.AccountUuid
      }
    }
    context.dispatch(OPEN_MODAL, refundPendingChargeModal)
  },
  async [RELEASE_HELD_CHARGE] (context, payload) {
    let releaseHeldChargeModal = {
      permalink: 'releaseHeldCharge',
      options: {
        title: 'Release Pre-Authorisation',
        actionLabel: 'Release'
      },
      params: {
        HeldChargeUuid: payload.HeldChargeUuid,
        AccountUuid: payload.AccountUuid
      }
    }
    context.dispatch(OPEN_MODAL, releaseHeldChargeModal)
  },
  async [CAPTURE_HELD_CHARGE] (context, payload) {
    let captureHeldChargeModal = {
      permalink: 'captureHeldCharge',
      options: {
        title: 'Capture Pre-Authorisation',
        actionLabel: 'Capture'
      },
      params: {
        HeldChargeUuid: payload.HeldChargeUuid,
        AccountUuid: payload.AccountUuid
      }
    }
    context.dispatch(OPEN_MODAL, captureHeldChargeModal)
  },
  async [CREATE_PENDING_CHARGE] (context, payload) {
    let createPendingChargeModal = {
      permalink: 'createPendingCharge',
      options: {
        title: 'Add Charge',
        actionLabel: 'Charge'
      },
      params: {
        HeldChargeUuid: payload.HeldChargeUuid,
        AccountUuid: payload.AccountUuid
      }
    }
    context.dispatch(OPEN_MODAL, createPendingChargeModal)
  },
  async [DISMISS_NOTIFICATIONS] (context) {
    await api.dismissNotifications()
    context.commit(LOAD_NOTIFICATIONS, [])
    context.commit(LOAD_NOTIFICATIONS_COUNT, 0)
  },
  async [DISMISS_NOTIFICATION] (context, payload) {
    let accountMessages = await api.dismissNotification(payload.uuid || payload)
    context.commit(LOAD_NOTIFICATIONS, accountMessages)
    context.commit(LOAD_NOTIFICATIONS_COUNT, accountMessages.length)
  },
  async [SNOOZE_NOTIFICATIONS] (context) {
    let accountMessages = await api.snoozeNotifications()
    context.commit(LOAD_NOTIFICATIONS, accountMessages)
  },
  async [SNOOZE_NOTIFICATION] (context, payload) {
    let accountMessages = await api.snoozeNotification(payload.uuid)
    context.commit(LOAD_NOTIFICATIONS, accountMessages)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js